import { combineReducers } from 'redux'
import authedUser from './authedUser'
import enquiries from './enquiries'
import offices from './offices'
import users from './users'
//import { loadingBarReducer } from 'react-redux-loading'

export default combineReducers({
	authedUser,
	enquiries,
	offices,
	users,
	//loadingBar: loadingBarReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js